import { RoadControlsForm } from '../../../../common/components/road-controls-set/road-controls.form';
import { Injectable } from '@angular/core';
import {
  ApplicationAppEntityApplicationRead,
  ApplicationAppEntityApplicationWrite,
  ParcelAppEntityParcelWrite
} from '../../../../../../../openapi';
import { FormControl, Validators } from '@angular/forms';
import { toNumber } from '../../../../../../../services/helpers';
import { environment } from '../../../../../../../../environments/environment';

@Injectable()
export class ConsentLocationOfBuildingsSmallerDistanceLocalisationDataForm extends RoadControlsForm {

  constructor() {
    super({
      geometry: new FormControl(null, environment.production ? Validators.required : []),
      description: new FormControl(null, [Validators.required, Validators.maxLength(255)]),

      distance: new FormControl('', [Validators.required, Validators.maxLength(255)]),

      parcels: new FormControl<ParcelAppEntityParcelWrite[]>(
        [], {
          nonNullable: true,
          validators: [Validators.minLength(1), Validators.maxLength(255)]
        }
      ),

      parcels2: new FormControl<ParcelAppEntityParcelWrite[]>(
        [], {
          nonNullable: true,
          validators: [Validators.minLength(1), Validators.maxLength(255)]
        }
      )
    });
  }

  public get geometry(): FormControl {
    return this.get('geometry') as FormControl;
  }

  public get parcels(): FormControl {
    return this.get('parcels') as FormControl;
  }

  public get parcels2(): FormControl {
    return this.get('parcels2') as FormControl;
  }

  public get parcelsValues(): ParcelAppEntityParcelWrite[] {
    return [...this.parcels2.value, ...this.parcels.value];
  }

  public override patchFormValues(value: ApplicationAppEntityApplicationRead): void {
    super.patchFormValues({
      ...value
    });
    this.parcels.setValue(value.parcels?.filter(v => v?.tag === 'parcels'));
    this.parcels2.setValue(value.parcels?.filter(v => v?.tag === 'parcels2'));
  }

  public toWriteModel(): ApplicationAppEntityApplicationWrite {
    const value = this.value;
    delete value.parcels;
    delete value.parcels2;
    return {
      ...value,
      distance: toNumber(value.distance),
      roadName: this.roadName.value,
      roadNumber: this.roadNumber.value,
      street: this.street?.value
    };
  }
}
